import { LogEntry, LogFields, LogLevel } from '@app/types/interfaces';
import { LoggerContext } from 'src/contexts/LoggerContext';
import React, { useCallback, useMemo, useState } from 'react';
import { getEnv, getTraceId } from 'src/lib/trace';

export const LoggerProvider = ({ children }) => {
    const [logs, setLogs] = useState<LogEntry[]>([]);
    const traceId = useMemo(() => getTraceId(), []);

    const appendLog = useCallback((level: LogLevel, message: string, options?: { event?: string; fields?: LogFields }) => {
        const env = getEnv();
        const event = options?.event || 'ui.log';
        const fields = options?.fields;
        const entry: LogEntry = {
            timestamp: new Date(),
            level,
            message,
            event,
            trace_id: traceId,
            service: 'dashboard',
            env,
            fields,
        };
        setLogs(prevLogs => [...prevLogs, entry]);
    }, [traceId]);

    const logInfo = useCallback((message: string, options?: { event?: string; fields?: LogFields }) => {
        appendLog('info', message, options);
    }, [appendLog]);

    const logWarn = useCallback((message: string, options?: { event?: string; fields?: LogFields }) => {
        appendLog('warn', message, options);
    }, [appendLog]);

    const logError = useCallback((message: string, options?: { event?: string; fields?: LogFields }) => {
        appendLog('error', message, options);
    }, [appendLog]);

    const loggerValue = useMemo(() => ({
        logInfo,
        logWarn,
        logError,
        logs,
        traceId,
    }), [logInfo, logWarn, logError, logs, traceId]);

    return (
        <LoggerContext.Provider value={loggerValue}>
            {children}
        </LoggerContext.Provider>
    );
};

export { LoggerContext };
